// extracted by mini-css-extract-plugin
export default {"file":"style_file__zC21L"};